import React,{useState} from 'react';
import { Bar, Line, Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
  } from 'chart.js';


  interface ChartProps {
    chartType: string;
    data: any;
    selectedOption: string;
    selectedGraph: string;
    selectedGraphName?: string;
    activitySelect?:string;
    xaxisRange?:string;
  }

const Chart: React.FC<ChartProps> = ({
  chartType,
  data,
  selectedOption,
  selectedGraph,
  selectedGraphName,
  activitySelect,
  xaxisRange,
}) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Filler,
        Legend
      );

      interface ChartType {
        label: string;
        component: any;
        backgroundColors?: string[];
        borderColors?: string[];
        stack?: boolean;
        fill?: boolean;
        selectedOption?: string;
        selectedGraph?: string;
        graphNameType?:string[];
        selectedGraphName?: string;
        activitySelect?:string;
        xaxisRange?:string;
        xAxisSelector?:string[];
      }

      interface ChartTypes {
        [key: string]: ChartType;
      }

      interface ChartOptions {
        responsive: boolean;
        aspectRatio: any;
        plugins: {
          legend: {
            position: string;
          };
          title: {
            display: boolean;
            text: string;
          };
        };
        scales?: { // Make scales optional
          x: {
            stacked: boolean;
          };
          y: {
            stacked: boolean;
            title: {
              display: true;
              text: string;
            };
          };
        };
      }
      
      interface ChartData {
        labels: string[];
        datasets: {
          label: string;
          data: number[];
          backgroundColor: string;
          borderColor: string;
          borderWidth: number;
          fill?: boolean; // Adjust as needed
        }[];
      }

      const chartTypes: ChartTypes = {
        bar: {
          label: 'Bar Chart',
          component: Bar,
          backgroundColors: ['rgba(53, 162, 235, 0.5)', 'rgba(23, 152, 225, 0.5)'],
          borderColors: ['rgb(53, 162, 235)', 'rgb(23, 152, 225)'],
        },
        line: {
          label: 'Line Chart',
          component: Line,
          backgroundColors: ['rgba(53, 162, 235, 0)', 'rgba(23, 152, 225, 0)'],
          borderColors: ['rgb(53, 162, 235)', 'rgb(23, 152, 225)'],
        },
        area: {
          label: 'Area Chart',
          component: Line,
          backgroundColors: ['rgba(75, 192, 192, 0.5)', 'rgba(54, 162, 235, 0.5)'],
          borderColors: ['rgb(75, 192, 192)', 'rgb(54, 162, 235)'],
        },
        stackedBar: {
          label: 'Stacked Bar Chart',
          component: Bar,
          backgroundColors: ['rgba(53, 162, 235, 0.5)', 'rgba(23, 152, 225, 0.5)'],
          borderColors: ['rgb(53, 162, 235)', 'rgb(23, 152, 225)'],
          stack: true,
        },
        pie: {
          label: 'Pie Chart',
          component: Pie,
          backgroundColors: ['#ccd5ae', '#e9edc9', '#fefae0', '#faedcd', '#d4a373'],
          borderColors: ['rgb(53, 162, 235)', 'rgb(23, 152, 225)', 'rgb(75, 192, 192)', 'rgb(255, 205, 86)', 'rgb(255, 99, 132)'],
        },
        // Add more chart types as needed
      };

      // Determine chart component and options
      // let chartTypeConfig = chartTypes[chartType];
      // if (!chartTypeConfig) {
      //   chartTypeConfig = chartTypes['bar'];
      // }
      const chartTypeConfig = chartTypes[chartType] || chartTypes['bar'];

      const options: ChartOptions = {
        responsive: true,
        aspectRatio: chartType === "pie" ? 2 : null,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: false,
            text: `Chart.js ${chartTypeConfig.label || 'Chart'}`,
          },
        },
        scales: chartType === "pie" 
          ? undefined // Set scales to undefined for pie chart
          : { 
            x: { 
              stacked: chartType === "stackedBar" || chartType === "area",
            }, 
            y: { 
              stacked: chartType === "stackedBar" || chartType === "area",
              title: {
                display: true,
                text: selectedGraphName === 'organism_type' ? 'Organism Count' :
                selectedGraphName === 'genus' ? 'Genus Count' :
                selectedGraphName === 'species' ? 'Species Count' :
                selectedGraphName === 'strain' ? 'Strain Count' :
                selectedGraphName === 'schedule' ? 'Schedule Count' :
                selectedGraphName === 'exception' ? 'Exception Count' :
                selectedGraphName === 'total_count' ? 'Total Count' :
                'Colony Counts'
              },
            },
          }
      };
      

  return (
    // <Bar options={options} data={data} />
    <div>
      <div className='m-3 px-2' style={{display: "flex", justifyContent: "center"}}>
          <p className='smallBoldText1' style={{fontSize: "15px"}}>{selectedGraph} 
          {selectedGraphName && <span> | By {selectedGraphName}</span>}
          {selectedOption && <span> | By {selectedOption}</span>}
          {activitySelect && <span> | By {activitySelect}</span>}</p>
      </div>
      <div className='d-flex justify-content-between m-2'>

 

      </div>
      <div className='graphWrap'>
      {React.createElement(chartTypes[chartType]?.component || chartTypes['bar'].component, { data, options })}
      </div>
    </div>
  )
}

export default Chart